import Box from "@mui/material/Box"
import Chip from "@mui/material/Chip"
import SelectMui from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import InputLabel from "@mui/material/InputLabel"
import FormControl from "@mui/material/FormControl"
import OutlinedInput from "@mui/material/OutlinedInput"
import { useTheme } from "@mui/material/styles"

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  }
}

export function Select({
  id,
  label,
  onChange,
  value,
  options,
  multiple = true,
}) {
  const theme = useTheme()
  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    onChange(typeof value === "string" ? value.split(",") : value)
  }

  return (
    <FormControl sx={{ width: "100%" }} size="small">
      <InputLabel id={id}>{label}</InputLabel>
      <SelectMui
        multiple={multiple}
        labelId={id}
        value={value}
        onChange={handleChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip size="small" key={value} label={value} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {options.map((opt) => (
          <MenuItem key={opt} value={opt} style={getStyles(opt, value, theme)}>
            {opt}
          </MenuItem>
        ))}
      </SelectMui>
    </FormControl>
  )
}
